import { IRfq } from '../../rfq';

import { IChannelNew } from './channel.interface';

export interface IChannelProduct {
  id :number;
  productName :string;
  shopifySku :string;
  rfqId :number;
  channelId :number;
  productFlagStatus :string;
  currentInventory :number;
  leadTimeDays :number;
  defaultSellingUnitId :number;
  shopifyInventoryLocationId :number;
  bufferQuantity :number;
  lastPushDatetime :Date;
  lastPushQuantity :number;
  syncStatus :string;
  remarks :string;
  defaultSellingUnit :number;
  channel :IChannelNew;
  rfq :IRfq;
  ignored :boolean;
}

export interface IChannelProductMappingV2 {
  id :number;
  channelId :number;
  channelLabel :string;
  appIntegrationAccountId :number;
  appIntegrationAccountLabel :string;
  productId :string;
  sku :string;
  productName :string;
  price :number;
  channelPushStocksOmsProductId :number;
  bufferQuantity :number;
  leadtimeDays :number;
  lumSkuId :number | null;
  appIntegrationAccountProductsLumSkuId :number | null;
  sellingUnitId :number | null;
  sellingUnitName :string | null;
  defaultUnitId :number | null;
  omsDefaultUnitName :string | null;
  sellingUnitClassId :number | null;
  rfqDefaultSellingUnitId :number | null;
  rfqDefaultSellingUnitName :string | null;
  rfqDefaultSellingUnitClassId :number | null;
  rfqProductName :string | null;
  rfqInternalSku :string | null;
  isChannelProductMapping :boolean;
  appIntegrationProductLumInternalSku :string | null;
  appIntegrationProductLumProductName :string | null;
  appIntegrationProductDefaultSellingUnitId :number | null;
  appIntegrationProductDefaultSellingUnitName :string | null;
  appIntegrationProductDefaultSellingUnitClassId :number | null;
  ignoreStock :number;
  productOverride :any; // TODO: Create interface for this
  lumSku :any; // TODO: Create interface for this
}

export interface IChannelProductRequestFilter {
  product_flag_status ?:string;
  mapped_to ?:string;
  [key :string] :string | undefined;
}

export interface IChannelProductMappingFeatureFlag {
  newKitsStructureEnabled :boolean;
  lotTrackingEnabled :boolean;
  customFieldsEnabled :boolean;
}

export enum EChannelProductAgField {
  SHOPIFY_SKU = 'shopifySku',
  PRODUCT_NAME = 'productName',
  PRODUCT_FLAG_STATUS = 'productFlagStatus',
  SYNC_STATUS = 'syncStatus',
  CHANNEL = 'channel',
  ID = 'id',
  RFQ = 'rfq',
  IGNORED = 'ignored',
}

export enum EChannelPushStockOMSProduct {
  ID = 'id',
  SKU = 'sku',
  PRODUCT_NAME = 'productName',
  LUM_SKU = 'lumSku',
  STOCK_LEVEL_PULLED = 'stockLevel',
  PRICE = 'price',
  QTY_AVAILABLE = 'rfqStocks',
  LAST_PUSHED = 'pushStockStatus',
  CHANNEL = 'channel',
  SELLING_UNIT = 'sellingUnitName',
  OMS_DEFAULT_UNIT = 'omsDefaultUnitName',
  BUFFER_QUANTITY = 'bufferQuantity',
  PRODUCT_STATUS = 'lumStatus',
  MAPPED_TO = 'omsProductType',
  LEAD_TIME_DAYS = 'leadtimeDays',
  INV_LOCATION = 'appIntegrationAccountInventoryLocationId',
  IGNORED = 'ignored',
}

export enum EChannelProductAgFilter {
  MAPPED = 'Mapped',
  UNMAPPED = 'Unmapped',

  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum EProductMappingType {
  CHANNEL = 'channel',
  APP_INTEGRATION_ACCOUNT = 'appIntegrationAccount',
}

export enum EChannelProductMappingSearchUomType {
  SELLING_UNIT = 'sellingUnit',
  DEFAULT_UNIT = 'defaultUnit',
}

export interface IAppIntegrationAccountProductOverride {
  id :number;
  channelId :number;
  channelLabel :string;
  appIntegrationAccountId :number;
  appIntegrationAccountLabel :string;
  productId :string;
  sku :string;
  productName :string;
  price :number;
  channelPushStocksOmsProductId :number | null;
  bufferQuantity :number | null;
  leadtimeDays :number | null;
  lumSkuId :string | null;
  appIntegrationAccountProductsLumSkuId :string | null;
  sellingUnitId :number | null;
  sellingUnitName :string | null;
  defaultUnitId :number | null;
  omsDefaultUnitName :string | null;
  sellingUnitClassId :number | null;
  rfqDefaultSellingUnitId :number | null;
  rfqDefaultSellingUnitName :string | null;
  rfqDefaultSellingUnitClassId :number | null;
  rfqProductName :string | null;
  rfqInternalSku :string | null;
  isChannelProductMapping :boolean;
  appIntegrationProductLumInternalSku :string | null;
  appIntegrationProductLumProductName :string | null;
  appIntegrationProductDefaultSellingUnitId :number | null;
  appIntegrationProductDefaultSellingUnitName :string | null;
  appIntegrationProductDefaultSellingUnitClassId :number | null;
}
